export interface SaPageState {
  activeTab: SaTabs;
}

export enum SaTabs {
  CHARACTERISTICS = "Characteristics",
  DIMENSIONS = "Dimensions",
}
